import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { Button, Container, Grid, Image, Typography } from "src/UILibrary"
import { ShowHeader } from "../../../states/showHeader"
import { useRecoilState } from "recoil"
import { Box } from "@mui/system"
import GeneralUser from "src/assets/imgs/general_user.png"
import Adviser from "src/assets/imgs/adviser.png"
import Company from "src/assets/imgs/company.png"
import { useNavigate } from "react-router-dom"
import LogoPNG from "src/assets/icons/logo.png"
import "./index.scss"
import { useMediaQuery } from "react-responsive"

export const UserTypeSelection = () => {
  const { t } = useTranslation("translation", { keyPrefix: "signup" })

  const isPC = useMediaQuery({ query: "(min-width: 1000px)" })

  const navigate = useNavigate()

  const [, setShowHeader] = useRecoilState(ShowHeader)

  useEffect(() => {
    setShowHeader(false)
  })

  return (
    <>
      <Container sx={{ maxWidth: "1205px" }}>
        <Image
          src={LogoPNG}
          imageStyle={{ width: "auto", height: "100%", mx: "auto" }}
          sx={{ height: "80px", cursor: "pointer", display: "flex" }}
          onClick={() => navigate("/")}
        />
        <Typography.Large
          color="textPrimary"
          sx={{
            my: "40px",
          }}
        >
          {t("new_user_signup")}
        </Typography.Large>
        {isPC ? (
          <Grid container sx={{ mt: "20px" }}>
            <Grid item md={4}>
              <Box
                display="flex"
                flexDirection="column"
                sx={{ maxWidth: "310px", pt: "10", pb: "10" }}
              >
                <Typography.SubHeadNormal textAlign="center">
                  {t("register_general_user")}
                </Typography.SubHeadNormal>
                <Image src={GeneralUser} sx={{ width: "310px", my: "40px" }} />
                <Box display="flex" sx={{ width: "100%", height: "72px" }}>
                  <Typography.SubTitleNormal
                    sx={{
                      fontFamily: "Noto Sans JP !important",
                    }}
                  >
                    {t("general_user_description")}
                  </Typography.SubTitleNormal>
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    minWidth: "240px",
                    py: "10px",
                    fontSize: "1rem",
                    fontFamily: "Noto Sans JP !important",
                    lineHeight: "1rem",
                    fontWeight: 700,
                    my: "40px",
                    mx: "auto",
                    borderRadius: 0,
                    ":hover": {
                      bgcolor: "#2DA389",
                    },
                  }}
                  onClick={() => navigate("/signup/user")}
                >
                  {t("here_for_general_user")}
                </Button>
              </Box>
            </Grid>
            <Grid item md={4}>
              <Box
                display="flex"
                flexDirection="column"
                sx={{ maxWidth: "310px", pt: "10", pb: "10" }}
              >
                <Typography.SubHeadNormal textAlign="center">
                  {t("register_adviser")}
                </Typography.SubHeadNormal>
                <Image src={Adviser} sx={{ width: "310px", my: "40px" }} />
                <Box display="flex" sx={{ width: "100%", height: "72px" }}>
                  <Typography.SubTitleNormal
                    sx={{
                      fontFamily: "Noto Sans JP !important",
                    }}
                  >
                    {t("adviser_description")}
                  </Typography.SubTitleNormal>
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    minWidth: "240px",
                    py: "10px",
                    fontSize: "1rem",
                    fontFamily: "Noto Sans JP !important",
                    lineHeight: "1rem",
                    fontWeight: 700,
                    my: "40px",
                    mx: "auto",
                    borderRadius: 0,
                    ":hover": {
                      bgcolor: "#2DA389",
                    },
                  }}
                  onClick={() => navigate("/signup/adviser")}
                >
                  {t("here_for_adviser")}
                </Button>
              </Box>
            </Grid>
            <Grid item md={4}>
              <Box
                display="flex"
                flexDirection="column"
                sx={{ maxWidth: "310px", pt: "10", pb: "10" }}
              >
                <Typography.SubHeadNormal textAlign="center">
                  {t("register_company")}
                </Typography.SubHeadNormal>
                <Image src={Company} sx={{ width: "310px", my: "40px" }} />
                <Box display="flex" sx={{ width: "100%", height: "72px" }}>
                  <Typography.SubTitleNormal
                    sx={{
                      fontFamily: "Noto Sans JP !important",
                    }}
                  >
                    {t("company_description")}
                  </Typography.SubTitleNormal>
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    minWidth: "240px",
                    py: "10px",
                    fontSize: "1rem",
                    fontFamily: "Noto Sans JP !important",
                    lineHeight: "1rem",
                    fontWeight: 700,
                    my: "40px",
                    mx: "auto",
                    borderRadius: 0,
                    ":hover": {
                      bgcolor: "#2DA389",
                    },
                  }}
                  onClick={() => navigate("/signup/company")}
                >
                  {t("here_for_company")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        ) : (
          <Box display="block" width="100%">
            <Box display="flex" flexDirection="column" sx={{ width: "100%", pt: "10", pb: "10" }}>
              <Typography.SubHeadNormal textAlign="center">
                {t("register_general_user")}
              </Typography.SubHeadNormal>
              <Image
                src={GeneralUser}
                sx={{ width: "100%", my: "40px" }}
                imageStyle={{ width: "100%" }}
              />
              <Box display="flex" sx={{ width: "100%" }}>
                <Typography.SubTitleNormal
                  sx={{
                    fontFamily: "Noto Sans JP !important",
                  }}
                >
                  {t("general_user_description")}
                </Typography.SubTitleNormal>
              </Box>
              <Button
                variant="contained"
                sx={{
                  minWidth: "240px",
                  py: "10px",
                  fontSize: "1rem",
                  fontFamily: "Noto Sans JP !important",
                  lineHeight: "1rem",
                  fontWeight: 700,
                  my: "20px",
                  mx: "auto",
                  borderRadius: 0,
                  ":hover": {
                    bgcolor: "#2DA389",
                  },
                }}
                onClick={() => navigate("/signup/user")}
              >
                {t("here_for_general_user")}
              </Button>
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              sx={{ width: "100%", pt: "10", pb: "10", my: "40px" }}
            >
              <Typography.SubHeadNormal textAlign="center">
                {t("register_adviser")}
              </Typography.SubHeadNormal>
              <Image
                src={Adviser}
                sx={{ width: "100%", my: "40px" }}
                imageStyle={{ width: "100%" }}
              />
              <Box display="flex" sx={{ width: "100%" }}>
                <Typography.SubTitleNormal
                  sx={{
                    fontFamily: "Noto Sans JP !important",
                  }}
                >
                  {t("adviser_description")}
                </Typography.SubTitleNormal>
              </Box>
              <Button
                variant="contained"
                sx={{
                  minWidth: "240px",
                  py: "10px",
                  fontSize: "1rem",
                  fontFamily: "Noto Sans JP !important",
                  lineHeight: "1rem",
                  fontWeight: 700,
                  my: "20px",
                  mx: "auto",
                  borderRadius: 0,
                  ":hover": {
                    bgcolor: "#2DA389",
                  },
                }}
                onClick={() => navigate("/signup/adviser")}
              >
                {t("here_for_adviser")}
              </Button>
            </Box>
            <Box display="flex" flexDirection="column" sx={{ width: "100%", pt: "10", pb: "10" }}>
              <Typography.SubHeadNormal textAlign="center">
                {t("register_company")}
              </Typography.SubHeadNormal>
              <Image
                src={Company}
                sx={{ width: "100%", my: "40px" }}
                imageStyle={{ width: "100%" }}
              />
              <Box display="flex" sx={{ width: "100%" }}>
                <Typography.SubTitleNormal
                  sx={{
                    fontFamily: "Noto Sans JP !important",
                  }}
                >
                  {t("company_description")}
                </Typography.SubTitleNormal>
              </Box>
              <Button
                variant="contained"
                sx={{
                  minWidth: "240px",
                  py: "10px",
                  fontSize: "1rem",
                  fontFamily: "Noto Sans JP !important",
                  lineHeight: "1rem",
                  fontWeight: 700,
                  my: "20px",
                  mx: "auto",
                  borderRadius: 0,
                  ":hover": {
                    bgcolor: "#2DA389",
                  },
                }}
                onClick={() => navigate("/signup/company")}
              >
                {t("here_for_company")}
              </Button>
            </Box>
          </Box>
        )}
      </Container>
    </>
  )
}
